<template>
    <div id="app">
        <router-view v-if="pageShow"/>
    </div>
</template>

<script>
import institutionApi from '@/request/api/institution';
import ResizeMixin from './ResizeHandler'
import userApi from '@/request/api/user';
import {mapGetters} from 'vuex';

export default {
    name: 'App',
    mixins: [ResizeMixin],
    computed: {
        ...mapGetters(['studentId']),
    },
    data() {
        return {
            pageShow: false,
            isShow: true,
        }
    },
    async created() {
        await this.getTokenofQuery();
        await this.getUserInfo();
        this.getThemeData();
        this.ifSctarchWork();
    },
    methods: {
        //获取query中的token
        getTokenofQuery() {
            new Promise(resolve => {
                if(this.$route.query && this.$route.query.token) {
                    let search = "";
                    let searchArr = location.search.slice(1).split('&');
                    searchArr.forEach((item, index) => {
                        if(item.includes('token=')) {
                            searchArr.splice(index, 1);
                        }
                    })
                    search = `?${searchArr.join('&')}`;
                    userApi.setToken(this.$route.query.token);
                    if(this.$router.history.current.path == "/sh")  this.$router.replace(`/sh?${search}`);
                    else if(this.$router.history.current.path == "/py") this.$router.replace(`/py?${search}`);
                }
                resolve(true);
            })
        },
        //token之后获取用户信息
        getUserInfo() {
            new Promise(resolve => {
                if(userApi.getToken() && !this.studentId) {
                    userApi.getCurrentUser(res => {
                        if(res.succeed) {
                            this.$store.commit('setDialogVisible', false)
                            this.$store.commit('setUserInfo', res.data)
                            this.$store.commit('setLoginBtnShow', false)
                            if(this.$route.name != 'matchDetail' && this.$route.name != 'classroom' && res.data.institution.realmNameHead != 'roborobo') 
                                this.$store.commit("setLessonDialogShow", true)
                        }
                        resolve(true);
                        return;
                    })
                }
                resolve(true);
            })
        },
        //主题
        getThemeData() {
            let domainNameHeader
            if (process.env.NODE_ENV == 'development'){
                // domainNameHeader = "roborobo"
                // domainNameHeader = "test"
                // domainNameHeader = "gmd"
                domainNameHeader = "op"
            } else if (process.env.NODE_ENV == 'production'){
                domainNameHeader = location.hostname.split('.')[0];
            }
            institutionApi.findCommunitySettingsByRN(domainNameHeader, res => {
                if(res.succeed) {
                    this.$store.commit('setInstitutionId', res.data.id);
                    this.$store.commit('setThemeData', res.data);
                    document.title = `${res.data.name}-编程社区`;
                    if(res.data.themeColor) {
                        sessionStorage.setItem('themeColor', res.data.themeColor);
                    }
                    if(res.data.logo) {
                        sessionStorage.setItem('logo', res.data.logo);
                    }
                    this.pageShow = true;
                    if(res.data.themeColor) {
                        document.documentElement.style.setProperty('--theme-color', res.data.themeColor);
                    }
                    if(res.data.fontColor) {
                        document.documentElement.style.setProperty('--theme-fontColor', res.data.fontColor);
                    }
                    if(res.data.activeColor) {
                        document.documentElement.style.setProperty('--theme-activeColor', res.data.activeColor);
                    }
                    if(res.data.icon) {
                        this.setIcon(res.data.icon);
                    } else {
                        this.setIcon('../static/favicon.ico');
                    }
                } else {
                    // this.$notify.error({
                    //     message: res.msg
                    // });
                    this.pageShow = true;
                    if(res.code != 401) {
                        this.$router.replace("error")
                    }
                }
            })
        },
        ifSctarchWork() {
            if(location.pathname.indexOf('scratchwork') > -1) {
                this.isShow = false;
            } else if(location.pathname.indexOf('worksplay') > -1) {
                this.isShow = false;
            }
        },
        setIcon(icon) {
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = icon;
            document.getElementsByTagName('head')[0].appendChild(link);
        }
    }
}
</script>
<style>
html {
    height: 100%;
    font-size: 14px !important;
}
body {
    height: 100%;
    margin: 0;
    padding: 0;
}
#app {
    width: 100%;
    height: 100%;
}
a {
    text-decoration: none;
}
ul, li {
    margin: 0;
    padding: 0;
    list-style: none;
}
.el-message-box__wrapper {
    z-index: 9999 !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue